import { Component, Inject, Optional } from '@angular/core';
import { ModificationCommonService } from '../../services/modification-common.service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ConfirmationBottomsheetComponent } from '../confirmation-bottomsheet/confirmation-bottomsheet.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-loaderbotomsheet',
  imports: [],
  templateUrl: './loaderbotomsheet.component.html',
  styleUrl: './loaderbotomsheet.component.less'
})
export class LoaderbotomsheetComponent {
  data:any
  constructor(private modificationCommonService: ModificationCommonService,
    @Optional() private _bottomSheetRef: MatBottomSheetRef<LoaderbotomsheetComponent> | null,
    @Optional() private dialogRef: MatDialogRef<LoaderbotomsheetComponent> | null,
        @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
        @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any

  ) {
    this.data = bottomSheetData || dialogData
    setTimeout(async () => {
      window.location.href = this.data.url
    },2000);
}
   vendorType :string = sessionStorage.getItem('vendorType') || ''
  
}
